/**
 * Created by zzy on 2019/7/22.
 */
import Login from './Login.vue'
export default Login



// WEBPACK FOOTER //
// ./src/views/login/index.js